import { Loader, Select } from "@mantine/core";
import React, { useEffect, useState } from "react";
import useEmployerImportConfigurationApiService from "../services/api/EmployeeImportConfigurationApiService";
import { HttpClientError } from "../../../providers/HttpClient";
import AuthProfile from "../../auth/services/model/AuthProfile";

type EmployeeImportConfigureSelectNameProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any,
  auth: AuthProfile,
}

const EmployeeImportConfigureNameSelect: React.FC<EmployeeImportConfigureSelectNameProps> = ({form, auth}) => {
  const [configOptions, setConfigOptions] = useState<string[]>([]);
  const {
    isLoading, isError, error, data
  } = useEmployerImportConfigurationApiService(auth.employer.id);

  useEffect(() => {
    if (data) {
      const tempOptions: string[] = [];
      data.forEach((element) => {
        if (!tempOptions.includes(element.name)) {
          tempOptions.push(element.name);
        }
      });
      
      setConfigOptions(tempOptions);
    }
  }, [data]);

  if (isError) {
    return <Select
      id="employer-configuration"
      name="employer-configuration"
      data={[]}
      placeholder="Something went wrong"
      disabled
      error={HttpClientError(error)}
    />;
  }

  if (!data) {
    return <Select
      id="employer-configuration"
      name="employer-configuration"
      data={[]}
      placeholder="No data available"
      disabled
    />;
  }

  return (
    <Select
      id="configurationName"
      name="configurationName"
      data={configOptions.map(it => ({
        value: it,
        label: it
      }))}
      label="Configuration Name"
      placeholder="Add or Select Configuration Name"
      searchable
      clearable
      onCreate={(query) => setConfigOptions((current) => [...current, query])}
      creatable
      getCreateLabel={(query) => `+ Create ${query}`}
      rightSection={isLoading ? <Loader size={16} /> : null}
      onChange={(value) => {
        form.setFieldValue("configurationName", value);
      }}
    />
  );
};


export default EmployeeImportConfigureNameSelect;